import * as Phaser from "phaser";

export class EmojiFlyEffect extends Phaser.GameObjects.Image {
  private readonly duration: number;
  private tweens: Phaser.Tweens.Tween[] = [];

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    atlas: string,
    frame: string,
    duration: number = 1500,
  ) {
    super(scene, x, y, atlas, frame);
    this.duration = duration;

    this.setOrigin(0.5, 1);
    this.setDepth(1000);
    this.setScale(1.5);

    this.tweens.push(this.scene.tweens.add({
      targets: this,
      y: { from: y, to: y - 250 },
      duration: this.duration,
      ease: "Linear",
    }));

    this.tweens.push(
      this.scene.tweens.add({
        targets: this,
        alpha: { from: 1, to: 0 },
        duration: this.duration,
        ease: "Linear",
      }).on("complete", (tween: Phaser.Tweens.Tween) => {
        tween.stop();
        this.destroy();
      }),
    );
  }

  override destroy(): void {
    this.tweens.forEach((tween) => tween.destroy());
    super.destroy();
  }
}
